import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface dashboardTilesInterface {
  fulfillment_saving_header: {
    total_save: number;
    saving_percentage: number;
  };
  inventory_needed_header: { needed: number; percentage_change: number };
  issues_count_header: { needed: number; percentage_change: number };
  missing_unit_header: { missing_units: number; percentage_change: number };
  sales_change_header: { sales: number; percentage_change: number };
  seller_header: {
    active: number;
    inactive: number;
    total: number;
  };
}

export interface DashboardState {
  dashboardTiles: dashboardTilesInterface | null;
  isUserActive: number;
}

export const initialState: DashboardState = {
  dashboardTiles: null,
  isUserActive: -1,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    addDashboardTiles: (
      state: DashboardState,
      action: PayloadAction<dashboardTilesInterface>
    ) => {
      state.dashboardTiles = action.payload;
    },
    changeIsUserActive: (
      state: DashboardState,
      action: PayloadAction<number>
    ) => {
      state.isUserActive = action.payload;
    },
  },
});

export const { addDashboardTiles, changeIsUserActive } = dashboardSlice.actions;
